<template>
  <div style="height:100%;">
    <el-row style="height:50%;">
      <el-col :span="10" style="height:100%;text-align:center;">
        <chart style="width:100%;height:100%;" :auto-resize="true" :options="c_device"></chart>
      </el-col>
    </el-row>
    <el-row style="height:50%;position:relative;">
      <el-col :span="24" style="height:100%;">
        <chart style="width:100%;height:calc(100% - 30px);" :auto-resize="true" :options="c_task"></chart>
        <div style="height:30px;padding-left:30px;">
          选择统计时间段（按月）：
          <el-date-picker v-model="month" type="month" format="yyyy-MM" value-format="yyyy-MM" placeholder="选择月" size="mini"
            style="width:110px;" :clearable="false"></el-date-picker>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  export default {
    components: {},
    watch: {
      month() {
        // 统计时间段改变后 重新获取统计数据
        this.getTaskStat();

        // 更改标题中的时间
        this.c_task.title.text =
          "检测任务统计（" +
          this.month.split("-")[0] +
          "年" +
          this.month.split("-")[1] +
          "月）";
      }
    },
    data() {
      return {
        c_device: {
          title: {
            text: "终端数量统计"
          },
          grid: {
            x: 40
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
              crossStyle: {
                color: "#999"
              }
            }
          },
          toolbox: {
            feature: {
              dataView: {
                show: true,
                readOnly: false
              },
              saveAsImage: {
                show: true
              }
            }
          },
          legend: {},
          xAxis: [{
            type: "category",
            data: ["设备状态"],
            axisPointer: {
              type: "shadow"
            }
          }],
          yAxis: [{
            type: "value",
            name: "台数",
            minInterval: 1
          }],
          series: []
        },

        c_task: {
          title: {
            text: "检测任务统计"
          },
          grid: {
            x: 40,
            y2: 30
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
              crossStyle: {
                color: "#999"
              }
            }
          },
          toolbox: {
            feature: {
              dataView: {
                show: true,
                readOnly: false
              },
              saveAsImage: {
                show: true
              }
            }
          },
          legend: {},
          xAxis: [{
            name: "日",
            type: "category",
            data: [],
            axisPointer: {
              type: "shadow"
            }
          }],
          yAxis: [{
            type: "value",
            name: "个数",
            minInterval: 1
          }],
          series: [{
              name: "周期任务",
              type: "bar",
              data: [],
              label: {
                show: true,
                formatter: function (params) {
                  if (params.value > 0) {
                    return params.value;
                  } else {
                    return "";
                  }
                },
                position: "top"
              }
            },
            {
              name: "即时任务",
              type: "bar",
              data: [],
              label: {
                show: true,
                formatter: function (params) {
                  if (params.value > 0) {
                    return params.value;
                  } else {
                    return "";
                  }
                },
                position: "top"
              }
            }
          ]
        },
        // 月份（显示该月的任务统计，格式YYYY-MM）
        month: "0000-00"
      };
    },
    mounted() {
      // 获取设备统计数据
      this.$getJSON("/stat/device_status", {}).then(res => {
        for (let i = 0; i < res.data.length; i++) {
          // 每个状态为一个单独的系列 这样就可以自动分配不同的颜色
          this.c_device.series.push({
            name: res.data[i]["name"],
            type: "bar",
            data: [res.data[i]["cnt"]],
            label: {
              show: true,
              formatter: "{c}",
              position: "top"
            }
          });
        }
      });

      // 设置任务显示月份为当前月
      let t = new Date();
      this.month = `${t.getFullYear()}-${t.getMonth() + 1}`;

      // 获取任务统计数据
      // this.getTaskStat();
    },
    methods: {
      getTaskStat() {
        // 初始化数据，长度为设定月份的天数
        let yearMonth = this.month.split("-").map(x => Number(x));
        let t = new Date(yearMonth[0], yearMonth[1], 0);
        let maxDay = t.getDate();
        let xAxisData = [];
        let periodTask = [];
        let realtimeTask = [];
        for (let i = 0; i < maxDay; i++) {
          xAxisData[i] = i + 1;
          periodTask[i] = 0;
          realtimeTask[i] = 0;
        }
        // 获取数据
        this.$getJSON("/stat/task", {
          yearMonth: this.month
        }).then(res => {
          for (let i = 0; i < res.data.length; i++) {
            let row = res.data[i];
            if (row["task_type"] == "周期任务") {
              periodTask[row["day"] - 1] = row["num"];
            } else {
              realtimeTask[row["day"] - 1] = row["num"];
            }
          }
          // 将数据设置到图表
          this.c_task.xAxis[0].data = xAxisData;
          this.c_task.series[0].data = periodTask;
          this.c_task.series[1].data = realtimeTask;
        });
      }
    }
  };

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/TaskStat.vue